module.exports = "/images/psa.jpg?ac99f7f150d8d838cc5e9468da1e2cb4";